import React from 'react';
import "../styles/Spinner.css"; 

const Spinner: React.FC = () => (
  <div className="spinner"></div>
);

export default Spinner;
